import axios from "axios";

export const buscarTrabajosPorCriterios = async (
  API_URL,
  criterios,
  onSuccess,
  onError
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos-por-criterios`,
      criterios,
      { withCredentials: true }
    );

    if (response.status === 200) {
      onSuccess(response.data); // aquí puedes setear estado con los resultados
    } else {
      onError("Error al buscar trabajos.");
    }
  } catch (error) {
    console.error("❌ Error al llamar trabajos-por-criterios:", error);
    onError("Ocurrió un error al buscar trabajos.");
  }
};

export const buscarTrabajosProyectos = async (
  API_URL,
  criterios,
  onSuccess,
  onError
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos-proyectos`,
      criterios,
      { withCredentials: true }
    );

    if (response.status === 200) {
      onSuccess(response.data); // aquí puedes setear estado con los resultados
    } else {
      onError("Error al buscar trabajos.");
    }
  } catch (error) {
    console.error("❌ Error al llamar trabajos-por-criterios:", error);
    onError("Ocurrió un error al buscar trabajos.");
  }
};

export const buscarTrabajosProyectosAgrupados = async (
  API_URL,
  criterios,
  onSuccess,
  onError
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos-proyectos-agrupados`,
      criterios,
      { withCredentials: true }
    );

    if (response.status === 200) {
      onSuccess(response.data);
    } else {
      onError("Error al buscar trabajos.");
    }
  } catch (error) {
    console.error("❌ Error al llamar trabajos-por-criterios:", error);
    onError("Ocurrió un error al buscar trabajos.");
  }
};

export const fetchTrabajosConAsignados = async (
  API_URL,
  criterios,
  limit = 5,
  offset = 0
) => {
  const { data } = await axios.post(
    `${API_URL}/api/centros-cargas-asignados?limit=${limit}&offset=${offset}`,
    criterios,
    { withCredentials: true }
  );
  return data;
};

export const fetchPermisionarios = async (
  API_URL,
  setPermisionarios,
  filtros = {}
) => {
  try {
    const response = await fetch(`${API_URL}/api/permisionarios-criterios`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(filtros),
    });

    if (!response.ok) {
      throw new Error("Error al consultar permisionarios");
    }

    const data = await response.json();
    setPermisionarios(data);
    return data;
  } catch (error) {
    console.error("❌ Error en obtenerPermisionarios:", error);
    return null;
  }
};

export const createClient = async (API_URL, clienteData) => {
  try {
    await axios.post(
      `${API_URL}/api/clientes`,
      {
        ...clienteData,
        comentarios: null, // Asegurar que sea null
      },
      { withCredentials: true }
    );

    const clientes = await axios.get(`${API_URL}/api/clientes`, {
      withCredentials: true,
    });

    const sortedClientes = clientes.data.sort((a, b) => b.id - a.id); // Ordenar por ID descendente

    const newCliente = sortedClientes[0]; // Obtener el último cliente creado

    return newCliente;
  } catch (error) {
    return null;
  }
};

export const updateClient = async (API_URL, cliente) => {
  try {
    const response = await axios.put(`${API_URL}/api/clientes`, cliente, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchDivisionesCFE = async (API_URL, setDivisionesCFE) => {
  try {
    const response = await axios.get(`${API_URL}/api/divisiones-cfe`, {
      withCredentials: true,
    });
    setDivisionesCFE(response.data);
  } catch (error) {
    console.error("Error al obtener las divisiones CFE:", error);
  }
};

export const fetchZonasCFE = async (API_URL, setZonasCFE, id) => {
  try {
    const response = await axios.get(`${API_URL}/api/zonas-cfe/${id}`, {
      withCredentials: true,
    });
    setZonasCFE(response.data);
  } catch (error) {
    console.error("Error al obtener las zonas CFE:", error);
  }
};

export const fetchTipoReportes = async (API_URL, setTiposReportes) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipo-reportes`, {
      withCredentials: true,
    });
    setTiposReportes(response.data);
  } catch (error) {
    console.error("Error al obtener los tipos de reportes:", error);
  }
};

export const fetchTiposAlineacion = async (API_URL, setTiposAlineacion) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-alineacion`, {
      withCredentials: true,
    });
    setTiposAlineacion(response.data);
  } catch (error) {
    console.error("Error al obtener los tipos de alineación:", error);
  }
};

export const fetchUsuariosHabilitadosPM = async (
  API_URL,
  setUsuariosHabilitadosPM
) => {
  try {
    const response = await axios.get(`${API_URL}/api/usuarios-habilitados-PM`, {
      withCredentials: true,
    });
    setUsuariosHabilitadosPM(response.data);
  } catch (error) {
    console.error("Error al obtener los usuarios habilitados PM:", error);
  }
};

export const createPermisionario = async (API_URL, permisionarioData) => {
  try {
    await axios.post(
      `${API_URL}/api/permisionarios`,
      {
        ...permisionarioData,
        comentarios: null,
      },
      { withCredentials: true }
    );

    const response = await fetch(`${API_URL}/api/permisionarios-criterios`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error("Error al consultar permisionarios");
    }

    const data = await response.json();

    const sortedPermisionarios = data.sort((a, b) => b.id - a.id);

    const newPermisionario = sortedPermisionarios[0];

    return newPermisionario;
  } catch (error) {
    return null;
  }
};

export const createProyecto = async (API_URL, proyectoData) => {
  try {
    await axios.post(
      `${API_URL}/api/proyectos`,
      {
        ...proyectoData,
        comentarios: null,
      },
      { withCredentials: true }
    );

    const response = await axios.get(`${API_URL}/api/proyectos`, {
      withCredentials: true,
    });

    const sortedProjects = response.data.sort((a, b) => b.id - a.id);
    const newProject = sortedProjects[0];
    return newProject;
  } catch (error) {
    return null;
  }
};

export const editProyecto = async (API_URL, proyectoData) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/proyectos`,
      {
        ...proyectoData,
        comentarios: null,
        destinatariosMail: proyectoData.destinatariosMail
          ? proyectoData.destinatariosMail
          : [],
      },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const eliminarProyecto = async (API_URL, proyectoId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/proyectos/${proyectoId}`,

      { withCredentials: true }
    );

    return response.data;
  } catch (error) {
    console.error("Error al eliminar el proyecto:", error);
    throw error;
  }
};

export const createEDT = async (API_URL, edtData) => {
  try {
    await axios.post(
      `${API_URL}/api/tipos-trabajos`,
      {
        ...edtData,
        comentarios: null,
      },
      { withCredentials: true }
    );

    const response = await axios.get(`${API_URL}/api/tipos-trabajos`, {
      withCredentials: true,
    });

    const sortedEDTs = response.data.sort((a, b) => b.id - a.id);

    const newEDT = sortedEDTs[0];

    return newEDT;
  } catch (error) {
    return null;
  }
};

export const createEDTWithPassword = async (API_URL, edtData) => {
  try {
    await axios.post(
      `${API_URL}/api/tipos-trabajos-password`,
      {
        ...edtData,
        comentarios: null,
      },
      { withCredentials: true }
    );

    const response = await axios.get(`${API_URL}/api/tipos-trabajos`, {
      withCredentials: true,
    });

    const sortedEDTs = response.data.sort((a, b) => b.id - a.id);

    const newEDT = sortedEDTs[0];

    return newEDT;
  } catch (error) {
    return null;
  }
};

export const createTrabajo = async (API_URL, trabajoData) => {
  if (!trabajoData.soporteRegionalCFE) {
    trabajoData.zonaCFE = null;
  }

  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos`,
      {
        ...trabajoData,
        comentarios: null,
        // puntoCarga: null,
        codigoCfe: null,
        notas: null,
      },
      { withCredentials: true }
    );

    return response.data;
  } catch (error) {
    return null;
  }
};

export const updateTrabajo = async (API_URL, trabajoData) => {
  if (!trabajoData.soporteRegionalCFE) {
    trabajoData.zonaCFE = null;
  }
  try {
    const response = await axios.put(
      `${API_URL}/api/trabajos`,
      {
        ...trabajoData,
        comentarios: null,
      },
      { withCredentials: true }
    );

    return response.data;
  } catch (error) {
    return null;
  }
};

export const fetchContenidosDinamicos = async (API_URL, trabajoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/contenidos-dinamicos?trabajoId=${trabajoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener los contenidos dinámicos:", error);
  }
};

export const fetchImagenes = async (API_URL, contenidoDinamicoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/imagenes?contenidoDinamicoId=${contenidoDinamicoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las imagenes:", error);
  }
};

export const fetchImage = async (API_URL, queryParams) => {
  try {
    const resp = await axios.get(
      `${API_URL}/api/descargar-imagen?${queryParams}`,
      {
        withCredentials: true,
        responseType: "arraybuffer",
      }
    );

    const contentType =
      resp.headers["content-type"] || "application/octet-stream";
    const disposition = resp.headers["content-disposition"];

    return {
      buffer: resp.data,
      contentType,
      filename: parseFilenameFromDisposition(disposition) || "image",
    };
  } catch (error) {
    console.error("Error al obtener la imagen:", error);
    throw error;
  }
};

function parseFilenameFromDisposition(cd) {
  if (!cd) return null;
  const m = /filename\*?=(?:UTF-8''|")?([^\";]+)"?/i.exec(cd);
  return m ? decodeURIComponent(m[1]) : null;
}

export const fetchParametros = async (API_URL, contenidoDinamicoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/parametros?contenidoDinamicoId=${contenidoDinamicoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener los parametros:", error);
  }
};

export const getUltimaActualizacion = async (API_URL, id, multimedia) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos-ultima-actualizacion/${id}?multimedia=${multimedia}`,
      {},
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener la ultima actualizacion:", error);
  }
};

export const fetchDocumentos = async (API_URL, trabajoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/documentos?trabajoId=${trabajoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener los documentos:", error);
  }
};

export const fetchCategoriaNombreImagen = async (
  API_URL,
  tipoTrabajoId,
  categoria
) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/categoria-nombre-imagen?tipoTrabajoId=${tipoTrabajoId}&categoria=${categoria}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener los usuarios habilitados PM:", error);
  }
};

export const uploadImage = async (
  API_URL,
  file,
  contenidoDinamicoId,
  etiqueta
) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(
      `${API_URL}/api/subir-imagenes?contenidoDinamicoId=${contenidoDinamicoId}&etiqueta=${etiqueta}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al subir la imagen:", error);
  }
};

export const uploadDocumentos = async (API_URL, file, trabajoId) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(
      `${API_URL}/api/subir-documentos?trabajoId=${trabajoId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al subir el documento:", error);
  }
};

export const cambiarOrdenComentariosImagenes = async (API_URL, multimedias) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/cambiar-orden-comentarios-imagenes`,
      { multimedias },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al cambiar el orden y comentarios:", error);
  }
};

export const cambiarComentariosImagenesSeleccion = async (
  API_URL,
  multimedias,
  categoriaId
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/cambiar-comentarios-imagenes-seleccion?categoriaId=${categoriaId}`,
      { multimedias },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al cambiar el orden y comentarios:", error);
  }
};

export const cambiarUsarOrden = async (API_URL, id, usarOrdenAutomatico) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/cambiar-usar-orden/${id}?usarOrdenAutomatico=${usarOrdenAutomatico}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al cambiar el orden:", error);
  }
};

export const borrarImagenes = async (API_URL, ids) => {
  try {
    const response = await axios.post(`${API_URL}/api/borrar-imagenes`, ids, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al borrar las imagenes:", error);
  }
};

export const fetchOpcionesRotacion = async (API_URL) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/opciones-rotacion-imagen`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las opciones de rotación:", error);
  }
};

export const rotacionImagenes = async (API_URL, ids, rotacionImagen) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/rotacion-imagenes`,
      { ids, rotacionImagen },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al rotar las imagenes:", error);
  }
};

export const deleteImage = async (API_URL, id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/imagenes/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al borrar la imagen:", error);
  }
};

export const updateImage = async (API_URL, imagenId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(
      `${API_URL}/api/actualizar-imagenes?imagenId=${imagenId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al subir la imagen:", error);
  }
};

export const descargarDocumento = async (API_URL, name, queryParams) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/descargar-documento/${name}?${queryParams}`,
      {
        withCredentials: true,
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al descargar el documento:", error);
  }
};

export const deleteDocument = async (API_URL, id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/documentos/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al borrar el documento:", error);
  }
};

export const generarZipImagenesContenidoDinamico = async (API_URL, id) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/generar-zip-imagenes-contenido-dinamico?id=${id}`,
      {},
      {
        withCredentials: true,
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al generar el zip de las imagenes:", error);
  }
};

export const generarZipImagenes = async (API_URL, trabajoId) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/generar-zip-imagenes?trabajoId=${trabajoId}`,
      {},
      {
        withCredentials: true,
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al generar el zip de las imagenes:", error);
  }
};

export const generarIDsImagenes = async (API_URL, imagenes, trabajoId) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/generar-ids-imagenes`,
      imagenes,
      trabajoId,
      {
        withCredentials: true,
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al generar el zip de las imagenes:", error);
  }
};

export const uploadVideo = async (API_URL, file, Id) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(
      `${API_URL}/api/subir-videos?Id=${Id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al subir el video:", error);
  }
};

export const fetchVideos = async (API_URL, trabajoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/videos?trabajoId=${trabajoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener los videos:", error);
  }
};

export const fetchVideosFase = async (API_URL, Id) => {
  try {
    const response = await axios.get(`${API_URL}/api/videos-fase?Id=${Id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los videos de la fase:", error);
  }
};

export const downloadVideo = async (API_URL, id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/descargar-videos-trabajo/${id}`,
      {
        withCredentials: true,
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al descargar el video:", error);
  }
};

export const deleteVideo = async (API_URL, id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/videos/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al borrar el video:", error);
  }
};

export const getInformacionAcometida = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/informacion-acometida/`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener la información acometida:", error);
  }
};

export const getListasParametro = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/listas-parametro`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener las listas de parámetro:", error);
  }
};

export const updateParametros = async (
  API_URL,
  contenidoDinamicoId,
  parametrosTrabajo
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/parametros?contenidoDinamicoId=${contenidoDinamicoId}`,
      { parametrosTrabajo },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al actualizar los parámetros:", error);
  }
};

export const descargarReporte = async (API_URL, contenidoDinamicoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/reportes-trabajos/${contenidoDinamicoId}`,
      {
        withCredentials: true,
        responseType: "arraybuffer",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al descargar el reporte:", error);
  }
};

export const getGafeteNumber = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/gafete`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener gafete:", error);
  }
};

export const fetchTipoParametrosTrabajo = async (
  API_URL,
  tipoTrabajoId,
  fase
) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/tipo-parametros-trabajo?tipoTrabajoId=${tipoTrabajoId}&fase=${fase}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener los tipos de parámetros de trabajo:",
      error
    );
  }
};

export const fetchFasesTrabajo = async (API_URL, tipoTrabajoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/fases-trabajo?tipoTrabajoId=${tipoTrabajoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las fases de trabajo:", error);
  }
};

export const cambiarOrdenTipoParametrosTrabajo = async (
  API_URL,
  tiposParametrosTrabajo
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/tipo-parametros-trabajo/cambiar-orden`,
      { tiposParametrosTrabajo },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al cambiar el orden de los tipos de parámetros:",
      error
    );
  }
};

export const cambiarOrdenCategoriaNombreImagen = async (
  API_URL,
  categoriasImagenes
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/categoria-nombre-imagen/cambiar-orden`,
      { categoriasImagenes },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al cambiar el orden de las categorías:", error);
  }
};

export const updateTipoParametrosTrabajo = async (
  API_URL,
  tipoParametroTrabajo
) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/tipo-parametros-trabajo/`,
      tipoParametroTrabajo,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al actualizar el tipo de parámetro de trabajo:",
      error
    );
  }
};

export const updateCategoriaNombreImagen = async (
  API_URL,
  categoriaNombreImagen
) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/categoria-nombre-imagen/`,
      categoriaNombreImagen,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al actualizar la categoría nombre imagen:", error);
  }
};

export const getReporteTipoParametrosTrabajo = async (API_URL, id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/reporte-tipo-parametros-trabajo/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener el reporte tipo parámetros de trabajo:",
      error
    );
  }
};

export const updateTipoTrabajo = async (API_URL, tipoTrabajo) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/tipos-trabajos`,
      tipoTrabajo,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al actualizar el tipo de trabajo:", error);
  }
};

export const deleteTipoTrabajo = async (API_URL, id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/tipos-trabajos/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al eliminar el tipo de trabajo:", error);
  }
};

export const createCategoriaNombreImagen = async (API_URL, categoriaData) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/categoria-nombre-imagen/`,
      categoriaData,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al crear la categoría nombre imagen:", error);
  }
};

export const createTipoParametrosTrabajo = async (
  API_URL,
  tipoParametroData
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/tipo-parametros-trabajo/`,
      tipoParametroData,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al crear el tipo de parámetro de trabajo:", error);
  }
};

export const getTiposParametros = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-parametros`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos de parámetros:", error);
  }
};

export const getCategoriasReportes = async (API_URL, tipoTrabajoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/categorias-reportes?tipoTrabajoId=${tipoTrabajoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las categorías de reportes:", error);
  }
};

export const deleteTipoParametrosTrabajo = async (API_URL, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/tipo-parametros-trabajo/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al eliminar el tipo de parámetro de trabajo:", error);
  }
};

export const deleteCategoriaNombreImagen = async (API_URL, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/categoria-nombre-imagen/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al eliminar la categoría nombre imagen:", error);
  }
};

export const fetchAsignacionesTrabajos = async (
  API_URL,
  trabajoId,
  categoria
) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/asignacion-trabajos?trabajoId=${trabajoId}&categoria=${categoria}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las asignaciones de trabajos:", error);
    throw error;
  }
};

export const getContactosInstaladoresEntregables = async (API_URL, id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/contactos-instaladores-entregables/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener los contactos de instaladores entregables:",
      error
    );
    throw error;
  }
};

export const createAsignacion = async (API_URL, asignacionData) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/asignacion`,
      asignacionData,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al crear la asignación:", error);
    throw error;
  }
};

export const definirFechaAsignacion = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/definir-fecha-asignacion`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al definir la fecha de la asignación:", error);
    throw error;
  }
};

export const asignacionFechaEjecucion = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/asignacion-fecha-ejecucion`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al asignar la fecha de ejecución:", error);
    throw error;
  }
};

export const getTiposCalculoProgreso = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-calculo-progreso`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos de cálculo de progreso:", error);
    throw error;
  }
};

export const cambiarTipoCalculoProgreso = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/asignacion-cambiar-tipo-calculo-progreso`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al cambiar el tipo de cálculo de progreso:", error);
    throw error;
  }
};

export const getDetallesStandby = async (API_URL) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/detalles-standby-asignacion`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener los detalles de standby:", error);
    throw error;
  }
};

export const aplicarStandbyAsignacion = async (
  API_URL,
  contenidoDinamicoId,
  data
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/aplicar-standby-asignacion?contenidoDinamicoId=${contenidoDinamicoId}`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al aplicar standby a la asignación:", error);
    throw error;
  }
};

export const concluirAsignacion = async (API_URL, asignacionId) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/asignacion-concluir/${asignacionId}`,
      {},
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al concluir la asignación:", error);
    throw error;
  }
};

export const desconcluirAsignacion = async (API_URL, asignacionId, razon) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/asignacion-desconcluir/${asignacionId}`,
      razon,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al desconcluir el trabajo de la asignación:", error);
    throw error;
  }
};

export const deleteAsignacion = async (API_URL, asignacionId, categoria) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/asignacion/${asignacionId}?categoria=${categoria}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al eliminar la asignación:", error);
    throw error;
  }
};

export const getEstatusLibranza = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/estatuses-libranza`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los estatus de libranza:", error);
    throw error;
  }
};

export const aplicarEstatusLibranza = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/aplicar-estatus-libranza`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al aplicar el estatus de libranza:", error);
    throw error;
  }
};

export const getHistorialEstatusLibranza = async (API_URL, cd) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/historial-estatus-libranza?cd=${cd}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener el historial de estatus de libranza:",
      error
    );
    throw error;
  }
};

export const finalizarEstatusLibranza = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/finalizar-estatus-libranza`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al finalizar el estatus de libranza:", error);
    throw error;
  }
};

export const getVisitasTrabajo = async (API_URL, contenidoDinamicoId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/visitas-trabajo?contenidoDinamicoId=${contenidoDinamicoId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las visitas de trabajo:", error);
    throw error;
  }
};

export const getTiposVisitas = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-visitas`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos de visitas:", error);
    throw error;
  }
};

export const createVisitaTrabajo = async (
  API_URL,
  contenidoDinamicoId,
  data
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/visitas-trabajo?contenidoDinamicoId=${contenidoDinamicoId}`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al crear la visita de trabajo:", error);
    throw error;
  }
};

export const getVisitaTrabajoById = async (API_URL, id) => {
  try {
    const response = await axios.get(`${API_URL}/api/visitas-trabajo/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener la visita de trabajo:", error);
    throw error;
  }
};

export const updateVisitaTrabajo = async (API_URL, data) => {
  try {
    const response = await axios.put(`${API_URL}/api/visitas-trabajo`, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al actualizar la visita de trabajo:", error);
    throw error;
  }
};

export const updatePermisionario = async (API_URL, payload) => {
  try {
    const response = await axios.put(`${API_URL}/api/permisionarios`, payload, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generarReporte = async (API_URL, id, categoria) => {
  await axios.get(
    categoria
      ? `${API_URL}/api/reporte-trabajo/${id}?categoria=${categoria}`
      : `${API_URL}/api/reporte-trabajo/${id}`,
    {
      withCredentials: true,
      responseType: "blob",
    }
  );
};

export const abrirReporte = async (API_URL, id, categoria) => {
  await axios.get(
    categoria
      ? `${API_URL}/api/reporte-trabajo/${id}?categoria=${categoria}`
      : `${API_URL}/api/reporte-trabajo/${id}`,
    {
      withCredentials: true,
      responseType: "blob",
    }
  );

  const blobRes = await axios.get(`${API_URL}/api/descargar-reporte/${id}`, {
    withCredentials: true,
    responseType: "blob",
  });

  return blobRes.data;
};

export const generarExcelAsignacionTrabajos = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/generar-excel-asignacion-trabajos`,
      data,
      {
        withCredentials: true,
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching information:", error);
    throw error;
  }
};

export const generarZipReportesTrabajos = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/generar-zip-reportes-trabajos`,
      data,
      {
        withCredentials: true,
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching information:", error);
    throw error;
  }
};

export const descargarExcelTrabajos = async (API_URL, data) => {
  try {
    const response = await axios.post(`${API_URL}/api/trabajos/excel`, data, {
      withCredentials: true,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching information:", error);
    throw error;
  }
};

export const descargarExcelTrabajosYParametros = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos/nuevo-excel`,
      data,
      {
        withCredentials: true,
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching information:", error);
    throw error;
  }
};

export const descargarPDFTrabajos = async (API_URL, data) => {
  try {
    const response = await axios.post(`${API_URL}/api/trabajos/pdf`, data, {
      withCredentials: true,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching information:", error);
    throw error;
  }
};

export const subirExcelTrabajos = async (API_URL, file) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos/subir-excel-trabajos`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validarExcelTrabajos = async (API_URL, file) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos/validar-excel-trabajos`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const aplicarExcelTrabajos = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trabajos/aplicar-excel-trabajos`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCategoriaReporte = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/categorias-reportes`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCategoriaReporte = async (API_URL, data) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/categorias-reportes`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCategoriaReporte = async (API_URL, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/categorias-reportes/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cambiarOrdenCategoriasReportes = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/categorias-reportes/cambiar-orden`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
